export const GNRL_SETTINGS_ACTION = {
    GNRL_SETTINGS_LOADING: 'GNRL_SETTINGS_LOADING',
    GNRL_SETTINGS_ERROR: 'GNRL_SETTINGS_ERROR',
    GNRL_SETTINGS_SUCCESS: 'GNRL_SETTINGS_SUCCESS',

    PASS_DOC_ID :'PASS_DOC_ID'

}